import { useCallback, useEffect } from "react";
import { useGetAccount, useGetLoginInfo } from "@/hooks";
import { useGetAccountInfo } from "@multiversx/sdk-dapp/hooks";
import { useRefreshAndSend } from "@/hooks/useRefreshAndSend";

export const SignTransactionProvider = () => {
  const { address } = useGetAccount();
  const { tokenLogin } = useGetLoginInfo();
  const { account } = useGetAccountInfo();
  const refreshAndSend = useRefreshAndSend();

  return null; // This provider doesn't render anything
};
